import * as AWS from 'aws-sdk';
import { Lambda } from 'aws-sdk';
import { getToken } from "../utils/useFetchUserAttributes";

const sendMessageFunction = process.env.REACT_APP_SERVICE_LAMBDA as string;
const awsRegion = process.env.REACT_APP_AWS_REGION as string;
const awsCognitoIdentityPoolId = process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID as string;
const userPoolAwsLogin = process.env.REACT_APP_AWS_UserPoolAwsLogin as string;

export const generateGuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0,
        v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export const sendMessageToLambda = (content: string, token: string, sharkSessionId: string, callback: any) => {
  const languageLocale = localStorage.getItem('lang');
  let { id_token } = getToken();

  const requestBody = {
    context: {
      lpEvent: {
        event: {
          message: content
        },
        conversationContext: {
          visitor: {
            sharkSessionId: sharkSessionId
          }
        }
      },
      selectedLanguage: languageLocale,
      tokenId: id_token
    }
  };

  try {
    let loginObj: any = {};
    loginObj[userPoolAwsLogin] = id_token;

    let awsCredentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: awsCognitoIdentityPoolId,
      Logins: loginObj
    });

    AWS.config.region = awsRegion;
    AWS.config.credentials = awsCredentials;

    awsCredentials.refresh((err) => {
      if (err) {
        console.error("Credentials refresh error", err);
        callback("Credential refresh failed");
      } else {
        const lambda = new Lambda({ region: awsRegion });

        const params = {
          FunctionName: sendMessageFunction,
          InvocationType: 'RequestResponse',
          LogType: 'None',
          Payload: JSON.stringify({ body: JSON.stringify(requestBody) })
        };

        lambda.invoke(params, (err, data) => {
          if (err) {
            console.error('Error calling lambda ', err);
            const errorResponse = {
              messages: ["Unable to get any response."]
            };
            callback(JSON.stringify(errorResponse));
          } else {
            const responsePayload = data.Payload;
            const responseString = JSON.stringify(responsePayload);

            const convert = JSON.parse(responseString, (key, value) => {
              if (typeof value === 'string' && value.startsWith('{') && value.endsWith('}')) {
                return JSON.parse(value);
              }
              return value;
            });

            callback(convert.body);
          }
        });
      }
    });
  } catch (error) {
    console.error(error);
    const errorResponse = {
      messages: ["Unable to get any response."]
    };
    callback(JSON.stringify(errorResponse));
  }
};

export const fetchPromptsParam = (callback: any) => {
  let { id_token } = getToken();

  try {
    let loginObj: any = {};
    loginObj[userPoolAwsLogin] = id_token;

    let awsCredentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: awsCognitoIdentityPoolId,
      Logins: loginObj
    });

    AWS.config.region = awsRegion;
    AWS.config.credentials = awsCredentials;

    awsCredentials.refresh((err) => {
      if (err) {
        console.error("SSM credential refresh error", err);
        const errorResponse = {
          messages: ["Unable to fetch param."]
        };
        callback(JSON.stringify(errorResponse));
      } else {
        const fetchParam = new AWS.SSM({ region: awsRegion });

        const params = {
          Name: '/superapp/example-prompts'
        };

        fetchParam.getParameter(params, (err, data) => {
          if (err) {
            console.error('Error calling SSM param ', err);
            const errorResponse = {
              messages: ["Unable to fetch param."]
            };
            callback(JSON.stringify(errorResponse));
          } else {
            const responsePayload = data?.Parameter;
            const response = responsePayload?.Value;
            callback(response);
          }
        });
      }
    });
  } catch (error) {
    console.error(error);
    const errorResponse = {
      messages: ["Unable to fetch param."]
    };
    callback(JSON.stringify(errorResponse));
  }
};

export const fetchPromptsParamFromConfig = async (callback: any) => {
  try {
    const response = await fetch('/PromptConfig.json');
    if (!response.ok) {
      throw new Error('Failed to fetch configuration');
    }

    const data = await response.json();
    callback(data);
  } catch (error) {
    console.error(error);
  }
};
